"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabelDialogParts = void 0;
const tslib_1 = require("tslib");
const catalog_messages_1 = require("@tableau/catalog-messages");
const DatasourceCanBaseIcon_1 = require("@tableau/icons/DatasourceCanBaseIcon");
const DatasourceServerBaseIcon_1 = require("@tableau/icons/DatasourceServerBaseIcon");
const DatasourceServerConnectionBaseIcon_1 = require("@tableau/icons/DatasourceServerConnectionBaseIcon");
const DatasourceTableBaseIcon_1 = require("@tableau/icons/DatasourceTableBaseIcon");
const DatasourceTableConnectionIcon_1 = require("@tableau/icons/DatasourceTableConnectionIcon");
const FlowBaseIcon_1 = require("@tableau/icons/FlowBaseIcon");
const TableauFileViewBaseIcon_1 = require("@tableau/icons/TableauFileViewBaseIcon");
const react_1 = tslib_1.__importDefault(require("react"));
const LabelStyles_1 = require("../LabelStyles");
function getToggleLabel(type, contentType) {
    switch (type) {
        case 'certification':
            return catalog_messages_1.Messages.certificationCheckboxLabel({ CONTENT_TYPE: getLabelForContentType(contentType) });
        case 'sensitivity':
            return catalog_messages_1.Messages.showSensitiveLabelMessage();
        case 'EXTRACT_REFRESH_FAILURE':
            return catalog_messages_1.Messages.dataQualityTriggerDialog_EnableTriggerToggleLabel_Datasource();
        case 'FLOW_RUN_FAILURE':
            return catalog_messages_1.Messages.dataQualityTriggerDialog_EnableTriggerToggleLabel_Flow();
        case 'warning':
            return catalog_messages_1.Messages.dataQualityDialog_v2_ShowWarning();
        default:
            throw Error('Label type does not exist');
    }
}
function getLabelForContentType(contentType) {
    switch (contentType) {
        case 'datasource':
            return catalog_messages_1.Messages.datasource_lower();
        case 'view':
            return catalog_messages_1.Messages.view_lower();
        case 'virtualConnection':
            return catalog_messages_1.Messages.virtualConnection_lower();
        case 'database':
            return catalog_messages_1.Messages.database_lower();
        case 'table':
            return catalog_messages_1.Messages.table_lower();
        case 'flow':
            return catalog_messages_1.Messages.flow_lower();
        case 'virtualConnectionTable':
            return catalog_messages_1.Messages.virtualConnectionTableLower();
        case 'column':
            return catalog_messages_1.Messages.column_lower();
        default:
            return catalog_messages_1.Messages.asset_lower();
    }
}
function getPluralLabelForContentType(contentType) {
    switch (contentType) {
        case 'datasource':
            return catalog_messages_1.Messages.datasources_lower();
        case 'view':
            return catalog_messages_1.Messages.views_lower();
        case 'virtualConnection':
            return catalog_messages_1.Messages.virtualConnections_lower();
        case 'database':
            return catalog_messages_1.Messages.databases_lower();
        case 'table':
            return catalog_messages_1.Messages.tables_lower();
        case 'flow':
            return catalog_messages_1.Messages.flows_lower();
        case 'virtualConnectionTable':
            return catalog_messages_1.Messages.virtualConnectionTablesLower();
        case 'column':
            return catalog_messages_1.Messages.columns_lower();
        default:
            return catalog_messages_1.Messages.assets_lower();
    }
}
function getDialogTitle(dialogType) {
    switch (dialogType) {
        case 'certification':
            return catalog_messages_1.Messages.certificationDialogTitle();
        case 'sensitivity':
            return catalog_messages_1.Messages.sensitivityDialogTitle();
        case 'EXTRACT_REFRESH_FAILURE':
            return catalog_messages_1.Messages.extractRefreshMonitoringDialogTitle();
        case 'FLOW_RUN_FAILURE':
            return catalog_messages_1.Messages.flowRunMonitoringDialogTitle();
        case 'warning':
            return catalog_messages_1.Messages.dataQualityWarningDialogTitle();
        default: {
            throw Error('This Label type does not exist');
        }
    }
}
function ContentTypeIcon({ contentType }) {
    switch (contentType) {
        case 'datasource':
            return react_1.default.createElement(DatasourceCanBaseIcon_1.DatasourceCanBaseIcon, { size: LabelStyles_1.LabelStyles.ICON_SIZE, alt: catalog_messages_1.Messages.Datasource() });
        case 'view':
            return react_1.default.createElement(TableauFileViewBaseIcon_1.TableauFileViewBaseIcon, { size: LabelStyles_1.LabelStyles.ICON_SIZE, alt: catalog_messages_1.Messages.View() });
        case 'virtualConnection':
            return react_1.default.createElement(DatasourceServerConnectionBaseIcon_1.DatasourceServerConnectionBaseIcon, { size: LabelStyles_1.LabelStyles.ICON_SIZE, alt: catalog_messages_1.Messages.VirtualConnection() });
        case 'database':
            return react_1.default.createElement(DatasourceServerBaseIcon_1.DatasourceServerBaseIcon, { size: LabelStyles_1.LabelStyles.ICON_SIZE, alt: catalog_messages_1.Messages.Database() });
        case 'table':
            return react_1.default.createElement(DatasourceTableBaseIcon_1.DatasourceTableBaseIcon, { size: LabelStyles_1.LabelStyles.ICON_SIZE, alt: catalog_messages_1.Messages.Table() });
        case 'flow':
            return react_1.default.createElement(FlowBaseIcon_1.FlowBaseIcon, { size: LabelStyles_1.LabelStyles.ICON_SIZE, alt: catalog_messages_1.Messages.Flow() });
        case 'virtualConnectionTable':
            return react_1.default.createElement(DatasourceTableConnectionIcon_1.DatasourceTableConnectionIcon, { size: LabelStyles_1.LabelStyles.ICON_SIZE, alt: catalog_messages_1.Messages.VirtualConnectionTable() });
        default:
            return null;
    }
}
function ContentItemIconDetails({ contentType, contentIcon, contentIconTitle }) {
    if (contentType === 'column') {
        return (react_1.default.createElement("div", { style: LabelStyles_1.LabelStyles.iconStyle, title: contentIconTitle }, contentIcon));
    }
    return (react_1.default.createElement("div", { style: LabelStyles_1.LabelStyles.iconStyle },
        react_1.default.createElement(ContentTypeIcon, { contentType: contentType })));
}
exports.LabelDialogParts = Object.freeze({
    getDialogTitle,
    getPluralLabelForContentType,
    getLabelForContentType,
    getToggleLabel,
    ContentTypeIcon,
    ContentItemIconDetails,
});
//# sourceMappingURL=LabelDialogParts.js.map